// SPDX-License-Identifier: MIT
// Durable per-project session history over the Rust get/set_agent_feed commands
// (agent-feed.json). Supersedes the 2.5.7 flat string[] shape — a legacy flat feed is
// migrated to one session/one request on read. The caller (welcome.ts) keeps the live
// session in memory and flushes via saveSessions (debounced during streaming).
import { tauriInvoke } from './tauri';
export type { Session, AgentRequest } from './session-policy';
import type { Session } from './session-policy';

type FeedFile = Record<string, Session[] | string[]>; // string[] = legacy flat feed

async function readAll(): Promise<FeedFile> {
  const raw = await tauriInvoke()('get_agent_feed');
  if (typeof raw !== 'string' || raw.length === 0) return {};
  try { const o = JSON.parse(raw); return o && typeof o === 'object' ? o : {}; } catch { return {}; }
}

function migrate(entry: Session[] | string[] | undefined): Session[] {
  if (!entry || entry.length === 0) return [];
  if (typeof entry[0] === 'string') {
    const lines = entry as string[];
    return [{ id: 'legacy', startedAt: '', requests: [{ id: 'legacy-r', prompt: '(historique importé)', kind: 'build', startedAt: '', lines }] }];
  }
  return entry as Session[];
}

export async function loadSessions(projectKey: string): Promise<Session[]> {
  return migrate((await readAll())[projectKey]);
}

export async function saveSessions(projectKey: string, sessions: Session[]): Promise<void> {
  const all = await readAll();
  all[projectKey] = sessions;
  await tauriInvoke()('set_agent_feed', { json: JSON.stringify(all) });
}

// The WHOLE feed, keyed by projectKey (= the project's local_dir), migrated.
// Cross-poste sync iterates this directly so it pushes sessions from wherever
// they actually live, instead of a fragile per-project local_dir lookup.
export async function loadAllSessions(): Promise<Record<string, Session[]>> {
  const all = await readAll();
  const out: Record<string, Session[]> = {};
  for (const [key, entry] of Object.entries(all)) out[key] = migrate(entry);
  return out;
}
